// Routes that do not require authentication. Used to avoid redirecting to
// /login from pages that are intentionally public (activation links, password
// reset, etc.).
const PUBLIC_ROUTE_PREFIXES = [
  '/login',
  '/user-activation',
  '/forgot-password',
  '/change-password',
  '/signup',
  '/viewer',
  '/logout',
  '/whatsapp-onboarding',
  // Frozen pre-v2 bridge until Meta's 2026-10-15 cutoff — remove with ENG-1911.
  '/whatsapp-onboarding-legacy',
  '/config-user-aggregator',
  '/version',
];

// Dynamic-segment routes that cannot be matched by a simple prefix check.
const PUBLIC_ROUTE_PATTERNS = [/^\/[^/]+\/oauth\/callback/];

const isPublicRoute = (pathname = window.location.pathname) =>
  PUBLIC_ROUTE_PREFIXES.some(prefix => pathname.startsWith(prefix)) ||
  PUBLIC_ROUTE_PATTERNS.some(pattern => pattern.test(pathname));

export default isPublicRoute;
